import React, {useEffect} from 'react'
import {Box, Grid, Typography} from "@mui/material";
import Subtitle from "../../components/Subtitle";
import {useAppDispatch} from "../../store/store";
import {sendEventsData} from "../../store/actions/actions";
import {useTranslation, Trans} from "react-i18next";
import {getCurrentLanguage} from "../../utils/Helpers";

const GrowthModelLayout = () =>{
    const dispatch = useAppDispatch();
    const {t,i18n} = useTranslation();
    let key = getCurrentLanguage(i18n);
    useEffect(() => {
        dispatch(sendEventsData({
            date: new Date().toLocaleString(),
            timestamp: new Date().getTime(),
            value:"/detail/growth-model",
            type:"pageView"
        }))
    }, []);
    return(
        <React.Fragment>
            <Box component="main">
                <Subtitle/>
                <br/>
                <br/>
                <Typography variant="h4" style={{fontWeight: "bold"}}>
                    {t('growth_model.title' as any)}
                </Typography>
                <br/>
                <Typography paragraph>
                    {t('growth_model.paragraph_1' as any)}
                </Typography>
                <Typography paragraph>
                    {t('growth_model.paragraph_2' as any)}
                </Typography>
                <Typography paragraph>
                    {t("growth_model.paragraph_3" as any, {sub:"\u2082"})}
                </Typography>
                <Typography paragraph>
                    {t('growth_model.subtitle1' as any)}
                </Typography>
                <Grid container alignItems='center' justifyContent='center'>
                    <Grid item xs='auto'>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexDirection: 'column',
                                maxWidth: "120%",
                            }}
                            component="img"
                            alt="Table Sealing 1"
                            src={require("../../assets/pages/detail/growth_model/"+key+"/growth_model.png")}
                        />
                    </Grid>
                </Grid>
                <br/>
                <br/>
                <Typography variant="h5">
                    {t('growth_model.subtitle2' as any)}
                </Typography>
                <br/>
                <Grid container>
                <Grid item xs={3}>
                        <Box
                            component="img"
                            alt="Table Sealing 1"
                            sx={{width: "90%",minHeight: 250}}
                            src={require("../../assets/pages/detail/growth_model/"+key+"/evapotranspiration.png")}
                        />
                    </Grid>
                    <Grid item xs={9}>
                        <Typography paragraph>
                            <div dangerouslySetInnerHTML={{__html: t("growth_model.module_1")}}/>
                        </Typography>
                        <Typography paragraph>
                            <div dangerouslySetInnerHTML={{__html: t("growth_model.module_2")}}/>
                        </Typography>
                    </Grid>
                </Grid>
                <br/>
                <Typography paragraph>
                    <div dangerouslySetInnerHTML={{__html: t("growth_model.module_3")}}/>
                </Typography>
                <Typography paragraph>
                    <div dangerouslySetInnerHTML={{__html: t("growth_model.module_4")}}/>
                </Typography>
                <Typography paragraph>
                    <div dangerouslySetInnerHTML={{__html: t("growth_model.module_5")}}/>
                </Typography>
                <Typography paragraph>
                    {t('growth_model.paragraph_4' as any)}
                </Typography>
            </Box>
        </React.Fragment>
    )

}
export default GrowthModelLayout
